import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

import Main from 'layouts/Main';
import Container from 'components/Container';
import { Form , Table } from './components';

import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'



const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})

analytics.page()

const History = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  

  return (
    <Main>
     
        <Container maxWidth={0.8}>
          <Form />
        </Container>
        <Container maxWidth={0.75} marginTop={0.4} paddingTop={'0 !important'}>
          <Table />
        </Container>
      
    </Main>
  );
};

export default History;
